export const CONTACT_SUPPORT_EMAIL = 'ccprosupport@servicetitan.com';
